import React from "react"
import Counter from "../counter/counter"
import { useStaticQuery, graphql } from "gatsby"

const HomeFacts = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          amountClients
          amountClientsContent
          amountProjects
          amountProjectsContent
          amountAwards
          amountAwardsContent
        }
      }
    }
  `)

  const {
    amountClients,
    amountClientsContent,
    amountProjects,
    amountProjectsContent,
    amountAwards,
    amountAwardsContent,
  } = data.wpContentSettings.home

  const factList = [
    { id: 1, amount: amountProjects, title: amountProjectsContent },
    { id: 2, amount: amountClients, title: amountClientsContent },
    { id: 3, amount: amountAwards, title: amountAwardsContent },
  ]
  return (
    <div className="row gx-lg-8 gx-xl-12 gy-10 gy-lg-0 mb-11 align-items-end">
      <div className="col-lg-8 mt-lg-2 mx-auto">
        <div className="row align-items-center counter-wrapper gy-6 text-center">
          {factList.map(({ id, title, amount }) => (
            <Counter key={id} number={amount} title={title} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default HomeFacts
